import {IWithSummaryModel} from "../../../../../common/permission/api/entity/iWithSummary.model";
import {InsoleDataSummaryModel} from "./insoleDataSummary.model";
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";
import {InsoleDataElementModel} from "./element/insoleDataElement.model";

export class InsoleDataModel implements IWithSummaryModel<InsoleDataSummaryModel> {
    summary: InsoleDataSummaryModel;
    footFrontTwistAngle: number;
    footFrontTwistType: LovValueSummary;
    footRearTwistAngle: number;
    footRearTwistType: LovValueSummary;
    footRootHeight: number;
    elements: InsoleDataElementModel[] = [];
}